// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff8533b5","455":"198ea40b","977":"a77af4d1"}[chunkId] + ".chunk.js";
};